var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTrashInactive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8799A8",
    fillRule: "evenodd",
    d: "M10.5 16.325c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm6 0c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm2 3c0 .55-.448 1-1 1h-10c-.552 0-1-.45-1-1v-11h12v11zm-8-14.672c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328v1.672h-4V4.653zm11 1.672h-5V4.653c0-1.284-1.121-2.328-2.5-2.328h-3c-1.379 0-2.5 1.044-2.5 2.328v1.672h-5c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-11h1c.55 0 1-.45 1-1s-.45-1-1-1z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrashInactive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash_inactive.742af4bd.svg";
export { ForwardRef as ReactComponent };